import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

export default function ApplyPage() {
    const [applies, setApplies] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        async function fetchApplies() {
            try {
                const res = await axios.get("/api/manage/apply", { timeout: process.env.REACT_APP_API_TIMEOUT });
                setApplies(res.data);
            } catch (err) {
                console.error("신청 목록을 불러오지 못했습니다: ", err.message);
            }
        }
        fetchApplies();
    }, []);

    const handleClick = (id) => {
        navigate(`/apply/${id}`);
    };

    return (
        <div style={{ maxWidth: 900, margin: "40px auto", fontFamily: "sans-serif" }}>
            <h2 style={{ textAlign: "center", marginBottom: 24 }}>제휴 신청 리스트</h2>
            <table style={{ width: "100%", borderCollapse: "collapse", boxShadow: "0 2px 8px rgba(0,0,0,0.05)" }}>
                <thead>
                    <tr style={{ background: "#f5f6fa" }}>
                        <th style={{ padding: "12px 8px", borderBottom: "2px solid #e1e1e1" }}>ID</th>
                        <th style={{ padding: "12px 8px", borderBottom: "2px solid #e1e1e1" }}>User ID</th>
                        <th style={{ padding: "12px 8px", borderBottom: "2px solid #e1e1e1" }}>회사명</th>
                        <th style={{ padding: "12px 8px", borderBottom: "2px solid #e1e1e1" }}>이메일</th>
                        <th style={{ padding: "12px 8px", borderBottom: "2px solid #e1e1e1" }}>신청일</th>
                    </tr>
                </thead>
                <tbody>
                    {applies.map((item, idx) => (
                        <tr
                            key={item.id}
                            style={{
                                background: idx % 2 ? "#fafbfc" : "#fff",
                                cursor: "pointer"
                            }}
                            onClick={() => handleClick(item.id)}
                        >
                            <td style={{ padding: "10px 8px", borderBottom: "1px solid #f0f0f0", textAlign: "center" }}>{item.id}</td>
                            <td style={{ padding: "10px 8px", borderBottom: "1px solid #f0f0f0", textAlign: "center" }}>{item.userId}</td>
                            <td style={{ padding: "10px 8px", borderBottom: "1px solid #f0f0f0", textAlign: "center" }}>{item.companyName}</td>
                            <td style={{ padding: "10px 8px", borderBottom: "1px solid #f0f0f0", textAlign: "center" }}>{item.email}</td>
                            <td style={{ padding: "10px 8px", borderBottom: "1px solid #f0f0f0", textAlign: "center" }}>{new Date(item.createdAt).toLocaleDateString()}</td>
                        </tr>
                    ))}
                    {applies.length === 0 && (
                        <tr>
                            <td colSpan={4} style={{ textAlign: "center", color: "#888", padding: 24 }}>
                                신청 내역이 없습니다.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
}